// extracted by mini-css-extract-plugin
module.exports = {"IconSize":"PasswordField_IconSize__byhz6"};